import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudRole = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'role/',
    params: params,
    defaultTenant: true,
    method: 'get'
  })
}

export const detailPrivateCloudRole = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'role/',
    method: 'get'
  })
}

export const editPrivateCloudRole = (data, id) => {
  let url = `${privateCloudBaseUrl}role/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    defaultTenant: true,
    method: method
  })
}

export const deletePrivateCloudRole = (id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}role/${id}/`,
    defaultTenant: true,
    method: 'delete'
  })
}

export const getPrivateCloudRoleAssignments = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'role_assignments/',
    params: params,
    defaultTenant: true,
    method: 'get'
  })
}
